module.exports = __webpack_public_path__ + "img/enrolled-student-5.e6e03126.png";